var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWizBundleColor = function SvgWizBundleColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    fill: "none",
    viewBox: "0 0 150 150"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F39C19",
    fillOpacity: 0.16,
    d: "M75 0C33.579 0 0 33.579 0 75s33.579 75 75 75 75-33.579 75-75S116.421 0 75 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#071C26",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M123.199 102.845c-.809 20.254-18.17 32.798-48.203 32.798-30.032 0-48.202-12.527-48.202-32.798 0-15.671 12.45-39.09 30.928-48.914 3.641 1.872 9.448 3.128 16.063 3.26h.008c.403.013.805.017 1.216.017 4.023 0 7.785-.411 10.995-1.126 2.609-.587 4.857-1.369 6.574-2.296 18.398 9.649 31.268 32.922 30.621 49.059ZM102.222 23.297c0 2.15-10.89 4.825-14.192 6.365-4.283 2-5.746 7.838-13.022 7.838-6.24 0-8.042-6.204-12.23-7.733-4.46-1.63-14.984-3.924-14.984-6.47 0-2.822 11.158-1.827 16.492-3.464 3.999-1.23 5.198-5.476 10.722-5.476 5.804 0 7.407 4.325 11.488 5.666 4.988 1.641 15.726.56 15.726 3.274Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#071C26",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M102.222 23.357c0 7.073-1.9 14.15-7.617 18.852-2.358 1.942-5.367 3.478-9.164 4.445-2.877.728-6.208 1.132-10.046 1.132h-.049c-9.27-.009-15.631-2.199-19.881-5.655-5.792-4.701-7.671-11.735-7.671-18.774M55.34 42.32c-1.049 1.434-1.63 3.01-1.63 4.664 0 2.65 1.485 5.097 4.006 7.096M94.714 42.394c1.016 1.414 1.576 2.965 1.576 4.59 0 2.547-1.373 4.91-3.72 6.863"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#071C26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M82.182 56.94s13.863 9.887 20.195 34.875M79.611 57.37s7.887 9.707 9.807 28.707"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F39C19",
    d: "M61.654 62.787c0 35.999 43.354 39.213 51.283 39.213-.635 15.774-14.334 24.415-37.788 24.415-23.455 0-37.641-9.753-37.641-25.54 0-12.204 9.72-30.441 24.146-38.088m13.486 48.856a4.285 4.285 0 1 0 0 8.57 4.285 4.285 0 0 0 0-8.57m-20.5-16.142c-.154-.53-.9-.526-1.045 0l-2.062 7.432a.55.55 0 0 1-.373.377l-7.41 2.131c-.53.154-.526.9 0 1.045l7.43 2.061a.55.55 0 0 1 .379.373l2.13 7.41c.154.531.9.527 1.045 0l2.062-7.431a.55.55 0 0 1 .373-.377l7.41-2.131c.53-.154.526-.9 0-1.045l-7.43-2.061a.55.55 0 0 1-.378-.374zm14.049-3.642c-.074-.25-.427-.25-.497 0l-.982 3.534a.27.27 0 0 1-.178.18l-3.523 1.015c-.252.074-.251.426 0 .497l3.533.981c.086.025.153.09.18.178l1.015 3.524c.074.251.427.251.498 0l.98-3.533a.27.27 0 0 1 .179-.181l3.523-1.015c.25-.074.251-.426 0-.497l-3.532-.981a.26.26 0 0 1-.18-.178zM52.606 81.214a4.286 4.286 0 1 0 .002 8.573 4.286 4.286 0 0 0-.002-8.573"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h150v150H0z"
  })))));
};
export default SvgWizBundleColor;